export default __webpack_public_path__ + "static/media/15.ffa76420.jpg";